module.exports = __webpack_public_path__ + "static/media/icon_06.ad262323.png";